import siteDown from '@/assets/img/maintenance.svg';
import logo from '@/assets/img/experian-logo.png';
import { Flex, Img, Text } from '@chakra-ui/react';

export const SiteDown = () => {
  return (
    <Flex
      alignItems='center'
      justifyContent='center'
      flexDir='column'
      h='100vh'
      w='full'
      position='absolute'
    >
      <Flex className='site-logo'>
        <Img src={logo} alt='Experian' />
      </Flex>
      <Img
        src={siteDown}
        alt='Site Down'
        h='50%'
        position='relative'
        top='3%'
      />
      <Flex
        alignItems='center'
        flexDir='column'
        w='full'
        py={12}
        background='linear-gradient(0deg, #FFFFFF, #F7FBFF)'
      >
        <Text fontSize='5xl' color='primary'>
          Sorry! We are under scheduled maintenance.
        </Text>
        <Text
          fontSize='2xl'
          lineHeight='10'
          color='gray.800'
          maxW='640'
          textAlign='center'
        >
          Our website is currently undergoing scheduled maintenance, we will be
          right back.
        </Text>
      </Flex>
    </Flex>
  );
};
